import React, { PropsWithChildren } from 'react'
import { concatStyles } from 'utils'

const CONTAINER_STYLES = 'flex flex-row w-screen h-auto box-border m-0'

interface IContainerProps {
  className?: string
}

export const Container: React.FC<PropsWithChildren<IContainerProps>> = ({
  className,
  children,
}) => {
  return (
    <div className={concatStyles([CONTAINER_STYLES, className])}>
      {children}
    </div>
  )
}
